export default __webpack_public_path__ + "static/media/img7.54e4e54c.PNG";